(function() {
    const initSlider = () => {
      const sliders = document.querySelectorAll('.popular__slider');
  
      sliders.forEach((slider, index) => {
        const articlesSlider = new Swiper(slider, {
          slidesPerView: 2,
          spaceBetween: 8,
          speed: 1000,
          pagination: {
            el: '.popular__slider--pagination',
            },
          navigation: {
            nextEl: ".popular__slider-nav .swiper-button-next",
            prevEl: ".popular__slider-nav .swiper-button-prev",
          },
          breakpoints: {
            576: {
              slidesPerView: 2,
              slidesPerGroup: 2
            },
            990: {
              slidesPerView: 3,
              slidesPerGroup: 3
            },
            1200: {
              slidesPerView: 4.1,
              slidesPerGroup: 4
            }
          }
        })
      })
    }
  
    const initSection = () => {
      const sections = document.querySelectorAll('.popular-products-section');
  
      const sectionResizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
        sections.forEach(section => {
          let top = calcTop(section);
          if (section.querySelector('.popular__slider-nav'))
            section.querySelector('.popular__slider-nav').style.top = top + 'px';
        })
      })
  
      sections.forEach(section => {
        sectionResizeObserver.observe(section);
      });
  
      initSlider();
    }
  
    initSection();
  
    document.addEventListener('shopify:section:load', function () {
      initSection();
    });
  })()